<template>
  <div>
    <div v-if="showHourSelector" class="planned-activities-hours-rang mb-5">
      <p class="choose-your-slot-title">
        {{ $t("chooseYourSlot") }}
      </p>
      <div
        class="planned-activities-hour"
        v-bind:class="hour === selectedHour ? 'active-hour' : ''"
        v-for="(hour, index) in getTimeSlot(groupActivity.plannedActivities)"
        :key="`${groupActivity.activity.id}-hour-${index}`"
        @click="selectedHour = hour"
      >
        {{ hour }}
      </div>
    </div>

    <div v-if="selectedHour !== null">
      <div
        v-for="plannedActivity in groupActivity.plannedActivities"
        :key="plannedActivity.id"
      >
        <planned-activity-row
          v-if="plannedActivityHour(plannedActivity) === selectedHour"
          :planned-activity="plannedActivity"
          :slotable="slotable"
          :max-slotable-places="maxSlotablePlaces"
          :slotable-callback="slotableCallback"
          :show-remaining-place="showRemainingPlace"
          :time-slot-format="formattedTimeSlot"
          :get-daily-activity="getDailyActivity"
          :direct-to-card="directToCard"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import VueI18n from "vue-i18n";
import moment from "@/services/momentjs";
import PlannedActivityRow from "@/components/partial/PlannedActivityRow";

export default {
  name: "PlannedActivitiesRow",
  components: { PlannedActivityRow },
  mixins: [LocaleMixin, ConfigMixin],
  props: {
    groupActivity: Object,
    slotable: {
      type: Boolean,
      default: false
    },
    maxSlotablePlaces: {
      type: [Number, String],
      default: null
    },
    slotableCallback: Function,
    timeSlotFormat: {
      type: String,
      default: "HH[h]mm"
    },
    showRemainingPlace: {
      type: Boolean,
      default: true
    },
    getDailyActivity: {
      type: Function,
      default: null
    },
    directToCard: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      selectedHour: null,
      showHourSelector: true,
      formattedTimeSlot: this.timeSlotFormat
        .replace(/\{/g, "[")
        .replace(/}/g, "]")
    };
  },

  mounted() {
    this.$i18n.locale = this.getLocale();
    if (this.getTimeSlot().length === 1) {
      this.selectedHour = this.getTimeSlot()[0];
      this.showHourSelector = false;
    }
  },

  methods: {
    getTimeSlot() {
      const hours = [];
      for (const plannedActivity of this.groupActivity.plannedActivities) {
        let hour = moment(plannedActivity.start_at).format(this.formattedTimeSlot);
        if (!hours.includes(hour)) hours.push(hour);
      }
      return hours;
    },

    plannedActivityHour(plannedActivity) {
      return moment(plannedActivity.start_at).format(this.formattedTimeSlot);
    }
  },

  // Translate component
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        chooseYourSlot: "Choose your slot :"
      },
      fr: {
        chooseYourSlot: "Choisissez votre créneaux :"
      }
    }
  })
};
</script>

<style lang="scss" src="../../assets/styles/buefy/base.scss"></style>
<style lang="scss">
.planned-activities-hours-rang {
  .choose-your-slot-title {
    text-decoration: underline;
  }
  .planned-activities-hour {
    display: inline-block;
    text-align: center;
    padding: 5px;
    margin: 3px 3px 3px 0;
    border-radius: 3px;
    font-weight: bold;
    color: white;
    background-color: #43a047;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    &.active-hour {
      background-color: #007bff;
    }
  }
}
</style>
